cobalt-checkbox {
  display: flex;
}

cobalt-checkbox .core-checkbox .checkbox-wrapper {
  padding: var(--number-spacing-none);
}
